import { render } from "./quotationlist.vue?vue&type=template&id=562bc5a5&scoped=true"
import script from "./quotationlist.vue?vue&type=script&lang=js"
export * from "./quotationlist.vue?vue&type=script&lang=js"

import "./quotationlist.vue?vue&type=style&index=0&id=562bc5a5&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562bc5a5"]])

export default __exports__